import * as React from 'react';
import { PlaceholderContent } from '../../core/placeholder/PlaceholderContent';
import { withItemDropTarget } from './withItemDropTarget';
import { jsx as _jsx } from "react/jsx-runtime";
export function PlaceholderContainerComponent({
  size,
  targetIndex,
  as,
  dataTestId,
  connectDropTarget
}) {
  return /*#__PURE__*/_jsx(PlaceholderContent, {
    as: as,
    dataTestId: dataTestId,
    dropRef: connectDropTarget,
    size: size,
    targetIndex: targetIndex
  });
}
const WrappedPlaceholderContainerComponent = withItemDropTarget(PlaceholderContainerComponent);
export function PlaceholderContainer(props) {
  const transformedProps = Object.assign({}, props, {
    columnIndex: props.targetIndex // Map targetIndex to columnIndex
  });
  return /*#__PURE__*/_jsx(WrappedPlaceholderContainerComponent, Object.assign({}, transformedProps));
}